import cn from "classnames";
import {
  ColumnDef,
  Table,
  TableState,
  createColumnHelper,
  getCoreRowModel,
  getGroupedRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { t } from "i18next";
import { RemoveAction } from "./RemoveAction";

export interface ShiftFullTimeAttendanceRecord {
  id: number;
  nameEn: string;
  nameZhHk: string;
  stationCode: string;
  role: string;
}

const columnHelper = createColumnHelper<ShiftFullTimeAttendanceRecord>();

export const useShiftFullTimeAttendanceColumns = (): ColumnDef<
  ShiftFullTimeAttendanceRecord,
  any
>[] => {
  return [
    columnHelper.accessor("nameEn", {
      header: () => t("fulltimeAttendance.column.nameEn"),
      cell: ({ cell }) => {
        return (
          <p
            className={cn(
              "font-normal",
              "text-sm",
              "leading-5",
              "text-black/86"
            )}
          >
            {cell.getValue()}
          </p>
        );
      },
    }),
    columnHelper.accessor("nameZhHk", {
      header: () => t("fulltimeAttendance.column.nameZhHk"),
      cell: ({ cell }) => {
        return (
          <p
            className={cn(
              "font-normal",
              "text-sm",
              "leading-5",
              "text-black/86"
            )}
          >
            {cell.getValue()}
          </p>
        );
      },
    }),
    columnHelper.accessor("role", {
      header: () => t("fulltimeAttendance.column.role"),
      cell: ({ cell }) => {
        return (
          <p
            className={cn(
              "font-normal",
              "text-sm",
              "leading-5",
              "text-black/86"
            )}
          >
            {cell.getValue()}
          </p>
        );
      },
    }),
    columnHelper.accessor("stationCode", {
      header: () => t("fulltimeAttendance.column.station"),
      cell: ({ cell }) => {
        return (
          <p
            className={cn(
              "font-normal",
              "text-sm",
              "leading-5",
              "text-black/86"
            )}
          >
            {cell.getValue()}
          </p>
        );
      },
    }),
    columnHelper.display({
      id: "action",
      cell: RemoveAction,
    }),
  ];
};

export const useShiftFullTimeAttendanceTable = (
  data: ShiftFullTimeAttendanceRecord[],
  state?: Partial<TableState>
): Table<ShiftFullTimeAttendanceRecord> => {
  const attendanceTableColumns = useShiftFullTimeAttendanceColumns();
  return useReactTable({
    data: data,
    columns: attendanceTableColumns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getGroupedRowModel: getGroupedRowModel(),
    defaultColumn: {
      minSize: 0,
      size: Number.MAX_SAFE_INTEGER,
      maxSize: Number.MAX_SAFE_INTEGER,
    },
    groupedColumnMode: false,
    manualSorting: false,
    enableRowSelection: false,
    state: state,
  });
};
